export default __webpack_public_path__ + "static/media/Call Up A Doc  Doc & RX-BBI (1).5f312f55.pdf";